export default __webpack_public_path__ + "68fc688ac2a96dd46830cb498b460269.png";